module.exports = __webpack_public_path__ + "static/img/y_zhxt24.c890a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_zhxt24.png
// module id = J60F
// module chunks = 73